import { cn } from '@/lib/cn';

export interface PeopleRowProps {
  /** Cuántas figuras se pintan. */
  total: number;
  /** Cuántas van rellenas (≤ total). */
  filled: number;
  /** `sm` = 16 × 22 px (carriles); `md` = fila a todo el ancho. */
  size?: 'sm' | 'md';
  /** La primera figura en el acento (la que está jugando). */
  highlightFirst?: boolean;
  className?: string;
}

/** Una fila de figuras (cabeza + cuerpo). Decorativa: siempre `aria-hidden`; quien la usa dice el dato con texto. */
export function PeopleRow({ total, filled, size = 'md', highlightFirst = false, className }: PeopleRowProps) {
  const count = Math.max(0, Math.floor(total));
  const on = Math.max(0, Math.min(count, Math.floor(filled)));
  return (
    <div
      aria-hidden="true"
      className={cn(size === 'md' ? 'grid gap-1.5' : 'flex flex-wrap items-center gap-1', className)}
      style={size === 'md' ? { gridTemplateColumns: `repeat(${Math.max(1, count)}, minmax(0, 1fr))` } : undefined}
    >
      {Array.from({ length: count }, (_, i) => (
        <svg
          key={i}
          viewBox="0 0 24 32"
          aria-hidden="true"
          focusable="false"
          className={cn(
            size === 'md' ? 'h-[30px] w-full' : 'h-[22px] w-4 shrink-0',
            i < on
              ? highlightFirst && i === 0
                ? 'text-[var(--color-accent-ink)]'
                : 'text-[var(--color-fg-primary)]'
              : 'text-[var(--color-border-default)]',
          )}
        >
          <circle cx="12" cy="7" r="6" fill="currentColor" />
          <path d="M2 32c0-9 4-15 10-15s10 6 10 15z" fill="currentColor" />
        </svg>
      ))}
    </div>
  );
}
